import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { UiToastComponent } from './ui-toast.component';
import { UiToastService } from './ui-toast.service';

@Component({
  selector: 'ui-toast-outlet',
  standalone: true,
  imports: [UiToastComponent],
  template: `
    <ui-toast
      [visible]="!!toastService.toast()"
      [type]="toastService.toast()?.type ?? 'info'"
      [title]="toastService.toast()?.title ?? ''"
      [message]="toastService.toast()?.message ?? ''"
      [durationMs]="toastService.toast()?.durationMs ?? 3000"
      (dismiss)="toastService.dismiss()"
    ></ui-toast>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiToastOutletComponent {
  protected readonly toastService = inject(UiToastService);
}
